import { c as create_ssr_component, s as spread, b as escape_object, a as escape_attribute_value, i as each, v as validate_component, e as escape } from "../../../../chunks/ssr.js";
import { p as post, a as put } from "../../../../chunks/api.js";
import dayjs from "dayjs";
import { B as Button } from "../../../../chunks/Button.js";
import { L as Label } from "../../../../chunks/Label.js";
import { I as Input } from "../../../../chunks/Input.js";
import { T as Textarea } from "../../../../chunks/Textarea.js";
import { M as Modal } from "../../../../chunks/Modal2.js";
import { c as compute_rest_props } from "../../../../chunks/utils.js";
import { twMerge } from "tailwind-merge";
import { H as Heading } from "../../../../chunks/Heading.js";
import { C as CopyToClipboard } from "../../../../chunks/CopyToClipboard.js";
import { E as EmployeeAvatar } from "../../../../chunks/EmployeeAvatar.js";
import { S as StatusTriggerButtons } from "../../../../chunks/StatusTriggerButtons.js";
const Blockquote = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["border", "italic", "borderClass", "bgClass", "bg", "baseClass", "alignment", "size"]);
  let { border = false } = $$props;
  let { italic = true } = $$props;
  let { borderClass = "border-s-4 border-gray-300 dark:border-gray-500" } = $$props;
  let { bgClass = "bg-gray-50 dark:bg-gray-800" } = $$props;
  let { bg = false } = $$props;
  let { baseClass = "font-semibold text-gray-900 dark:text-white" } = $$props;
  let { alignment = "left" } = $$props;
  let { size = "lg" } = $$props;
  let alignmentClasses = {
    left: "text-left",
    center: "text-center",
    right: "text-right"
  };
  const sizes = {
    xs: "text-xs",
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
    xl: "text-xl",
    "2xl": "text-2xl",
    "3xl": "text-3xl",
    "4xl": "text-4xl",
    "5xl": "text-5xl",
    "6xl": "text-6xl",
    "7xl": "text-7xl",
    "8xl": "text-8xl",
    "9xl": "text-9xl"
  };
  if ($$props.border === void 0 && $$bindings.border && border !== void 0) $$bindings.border(border);
  if ($$props.italic === void 0 && $$bindings.italic && italic !== void 0) $$bindings.italic(italic);
  if ($$props.borderClass === void 0 && $$bindings.borderClass && borderClass !== void 0) $$bindings.borderClass(borderClass);
  if ($$props.bgClass === void 0 && $$bindings.bgClass && bgClass !== void 0) $$bindings.bgClass(bgClass);
  if ($$props.bg === void 0 && $$bindings.bg && bg !== void 0) $$bindings.bg(bg);
  if ($$props.baseClass === void 0 && $$bindings.baseClass && baseClass !== void 0) $$bindings.baseClass(baseClass);
  if ($$props.alignment === void 0 && $$bindings.alignment && alignment !== void 0) $$bindings.alignment(alignment);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  return `<blockquote${spread(
    [
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge(baseClass, alignmentClasses[alignment], sizes[size], bg && bgClass, border && borderClass, italic && "italic", $$props.class))
      }
    ],
    {}
  )}>${slots.default ? slots.default({}) : ``}</blockquote> `;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let employees = [];
  let reminders = [];
  let open = false;
  let modalContent = { notes: "", completed: false };
  let units = [];
  let step = 0;
  let steps = [
    {
      text: "Erreicht?",
      buttons: [
        {
          text: "Ja",
          color: "primary",
          action: () => {
            step = 1;
          }
        },
        {
          text: "Nein",
          color: "red",
          action: () => {
            open = false;
          }
        }
      ]
    },
    { text: "Freundliche Begrüßung" },
    {
      text: "Wie bist du auf uns aufmerksam geworden?",
      input: "reference",
      type: "text"
    },
    {
      text: "Zum Ablauf: Du stellst dich vor, wir (REcrew) stellen uns vor, dann sprechen wir über nächste Schritte und Konditionen. Ok?"
    },
    {
      text: "Aufforderung zur Vorstellung",
      input: "notes",
      type: "text"
    },
    {
      text: "Wie alt bist du?",
      input: "age",
      type: "number"
    },
    {
      text: "Hast du schon Erfahrung in Gastronomie oder woanders?",
      input: "experience",
      type: "text"
    },
    {
      text: "Was machst Du derzeit, wie ist Dein Status – Schüler, Student, Azubi o. ä.?",
      input: "status",
      type: "text"
    },
    {
      text: "Wie oft möchtest Du von Mo-So arbeiten? Gibt es zeitliche Einschränkungen?",
      input: "daysPerWeek",
      type: "text"
    },
    {
      text: "Ab wann ist Einstieg möglich (Beginn immer Monats 1.)",
      input: "startDate",
      type: "date"
    },
    {
      text: "Hast du noch andere vertragliche Beschäftigungen?",
      input: "employment",
      type: "text"
    },
    {
      text: "Vorstellung REcrew: Personalvermittler für die Gastronomie in München,\nSitz in der Schellingstraße/Univiertel und weiteren\nStandorten in D., derzeitiger Fokus Service.\nUnsere Kunden sind Caterer und Hotels aus dem\ngehobenen Segment (Beispiele).\nJobarten (Hotel: früh/spät Bar, Restaurants, Bankett;\nCaterer: unterschiedl. Events wie Messe, Fußballspiele,\nFirmen- und private VAs an unterschiedl. Locations).\nVermittlung über Terminal App."
    },
    {
      text: "Bewerberprozess: Get-to-know-Treffen (GTK) kurze\nAblaufbeschreibung.\nVorstellung des Village (Treffpunkt bei Schichten\naußerhalb von MUC, Café fürs Team, Schulungsort und\nOffice)."
    },
    {
      text: "Nächste Schritte - wie geht’s jetzt weiter:\nZusendung Stammdatenblatt zum Ausfüllen, dann folgt\nEinladung zum GTK mit Auswahl an Terminen.\nNach GTK und beidseitigem positiven Eindruck folgt\nVertragsangebot durch Legal. (Erkl. Gehaltsmodell)\nNach Vertragsunterzeichnung folgen die Zugangsdaten\nzur App, Einstiegsinfos und Anruf zur Vereinbarung der\nersten Einsätze durch Dispo."
    },
    {
      text: "Hast du noch offene Fragen?",
      input: "question",
      type: "text"
    },
    {
      text: "Verabschiedung",
      buttons: [
        {
          text: "Abschließen",
          color: "primary",
          action: () => {
            finalizeInterview();
          }
        }
      ]
    }
  ];
  const finalizeInterview = async () => {
    let html = "";
    steps.forEach((step2) => {
      if (step2.input) {
        html += `<div class="mb-2"><p class="font-bold">${step2.text}</p><p>${modalContent[step2.input]}</p></div>`;
      }
    });
    await post(`/employee/${modalContent.employee.uuid}/timeline`, { content: html });
    let reminder = reminders.find((x) => x.employeeId === modalContent.employee.id);
    reminder.doneAt = dayjs().unix();
    await put(`/employee/${modalContent.employee.uuid}/reminder/${reminder.id}`, reminder);
    modalContent.completed = true;
  };
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-dflm9e_START -->${$$result.title = `<title>Telefontermine</title>`, ""}<!-- HEAD_svelte-dflm9e_END -->`, ""} ${each(reminders.sort((a, b) => a.remindAt.stamp - b.remindAt.stamp), (reminder) => {
      let employee = employees.find((x) => x.id === reminder.employeeId);
      return ` <div class="grid grid-cols-4 gap-3 items-center border-b pb-1"><div>${escape(dayjs.unix(reminder.remindAt.stamp).format("DD.MM. HH:mm"))}</div> <div>${escape(employee.name)}</div> <div class="flex gap-2"><a href="${"tel:" + escape(employee.mobile, true)}">${escape(employee.mobile)}</a> ${validate_component(CopyToClipboard, "CopyToClipboard").$$render($$result, { textToCopy: employee.mobile }, {}, {})}</div> <div>${validate_component(Button, "Button").$$render($$result, { size: "xs" }, {}, {
        default: () => {
          return `Frageboden`;
        }
      })}</div> </div>`;
    })} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "xl",
        title: modalContent?.employee?.name,
        open
      },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<div class="flex gap-3"><div class="grid gap-3 items-center border rounded p-3">${validate_component(EmployeeAvatar, "EmployeeAvatar").$$render(
            $$result,
            {
              size: "2xl",
              employee: modalContent?.employee
            },
            {},
            {}
          )} <p>${escape(units.find((x) => x.id === modalContent?.employee?.unitId)?.name)}</p> <pre class="w-full overflow-x-auto">${escape(modalContent?.employee?.note || "")}</pre></div> <div class="flex-1">${modalContent.completed ? `${validate_component(StatusTriggerButtons, "StatusTriggerButtons").$$render($$result, { employee: modalContent?.employee }, {}, {})} <div class="mt-5">${validate_component(Button, "Button").$$render($$result, { color: "yellow" }, {}, {
            default: () => {
              return `Schließen`;
            }
          })}</div>` : `<div class="flex gap-3"><div class="flex-1">${validate_component(Heading, "Heading").$$render($$result, { tag: "h3", customSize: "text-xl" }, {}, {
            default: () => {
              return `Telefoninterview`;
            }
          })} ${validate_component(Blockquote, "Blockquote").$$render(
            $$result,
            {
              border: true,
              bg: true,
              size: "xl",
              class: "p-3"
            },
            {},
            {
              default: () => {
                return `${escape(steps[step].text)}`;
              }
            }
          )} ${steps[step].hasOwnProperty("input") ? `${validate_component(Label, "Label").$$render($$result, { class: "mt-5 space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-1q8c901">Antwort</span> ${validate_component(Input, "Input").$$render(
                $$result,
                {
                  type: steps[step].type,
                  value: modalContent[steps[step].input]
                },
                {
                  value: ($$value) => {
                    modalContent[steps[step].input] = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}` : ``} <div class="flex gap-3 mt-5">${steps[step].buttons ? `${each(steps[step].buttons, (button) => {
            return `${validate_component(Button, "Button").$$render($$result, { color: button.color }, {}, {
              default: () => {
                return `${escape(button.text)}`;
              }
            })}`;
          })}` : `${validate_component(Button, "Button").$$render($$result, {}, {}, {
            default: () => {
              return `Weiter`;
            }
          })}`}</div> <div class="flex gap-1 mt-8">${each(steps, (_, index) => {
            return `${validate_component(Button, "Button").$$render(
              $$result,
              {
                size: "xs",
                color: step === index ? "primary" : "secondary"
              },
              {},
              {
                default: () => {
                  return `${escape(index + 1)}`;
                }
              }
            )}`;
          })}</div></div> <div>${validate_component(Heading, "Heading").$$render($$result, { tag: "h3", customSize: "text-xl" }, {}, {
            default: () => {
              return `Notizen`;
            }
          })} ${validate_component(Textarea, "Textarea").$$render(
            $$result,
            { rows: "4", value: modalContent.notes },
            {
              value: ($$value) => {
                modalContent.notes = $$value;
                $$settled = false;
              }
            },
            {}
          )}</div></div>`}</div></div>`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
